"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var move_1 = require("../move");

var position_1 = require("../position");

var rule_1 = require("../rule");

var sfen_parser_1 = require("../sfen-parser");

var SfenPositionRegex = /^\s*(position\s+)(sfen\s+[^m]+|startpos)(\s+moves\s+.*)?$/;
var SfenStringRegex = /sfen\s+([^\n]*)/;

function parseSfenString(sfen) {
  try {
    var position = sfen_parser_1.parse(sfen);
    return {
      type: "success",
      game: {
        positions: [position],
        sfenPositions: [position_1.generateSfen(position)],
        turns: 1,
        moves: [],
        isChecked: [rule_1.isChecked(position)]
      }
    };
  } catch (error) {
    return {
      type: "parse_error",
      message: error.toString()
    };
  }
}

exports.parseSfenString = parseSfenString;

function parseSfenPosition(sfenPosition) {
  try {
    var result = SfenPositionRegex.exec(sfenPosition);
    if (!result) return {
      type: "parse_error",
      message: "regex failed"
    };
    var st = result[2];
    var position = st === "startpos" ? position_1.getInitialPosition() : sfen_parser_1.parse(SfenStringRegex.exec(st)[1]);
    var positions = [position];
    var moves = [];
    var mv = result[3];

    if (mv) {
      var sfenMoves = mv.split(" ").filter(function (m) {
        return m;
      }).slice(1);

      for (var _i = 0, sfenMoves_1 = sfenMoves; _i < sfenMoves_1.length; _i++) {
        var sfenMove = sfenMoves_1[_i];
        var move = move_1.createMoveFromSfen(sfenMove, position);
        if (!move) return {
          type: "parse_error",
          message: "move parse failed"
        };
        moves.push(move);
        position = position_1.doMove(position, move);
        positions.push(position);
      }
    }

    return {
      type: "success",
      game: {
        positions: positions,
        sfenPositions: positions.map(position_1.generateSfen),
        isChecked: positions.map(rule_1.isChecked),
        moves: moves,
        turns: positions.length
      }
    };
  } catch (error) {
    return {
      type: "parse_error",
      message: error.toString()
    };
  }
}

exports.parseSfenPosition = parseSfenPosition;